/**
 * Utilidades para manejo de períodos de tiempo
 * Mapeo centralizado de períodos usado por PeriodFilter y componentes de gráficos
 */

// Definición de períodos disponibles
export const PERIODS = [
  { value: "last_week", label: "Última semana" },
  { value: "last_month", label: "Último mes" },
  { value: "last_3_months", label: "Últimos 3 meses" },
  { value: "last_6_months", label: "Últimos 6 meses" },
  { value: "last_year", label: "Último año" },
  { value: "custom", label: "Personalizado" },
];

// Mapa de valores a etiquetas para acceso rápido
const periodMap = PERIODS.reduce((acc, period) => {
  acc[period.value] = period.label;
  return acc;
}, {});

/**
 * Obtiene la etiqueta de un período
 * @param {string} periodValue - Valor del período (ej: "last_week")
 * @returns {string} - Etiqueta del período (ej: "Última semana")
 */
export const getPeriodLabel = (periodValue) => {
  return periodMap[periodValue] || "";
};

/**
 * Genera el título completo del período para mostrar en gráficos
 * @param {string} period - Valor del período
 * @param {object} customDates - Objeto con startDate y endDate para períodos personalizados
 * @returns {string} - Título formateado del período
 */
export const getPeriodTitle = (period, customDates = null) => {
  if (period === "custom" && customDates) {
    return `${customDates.startDate} - ${customDates.endDate}`;
  }
  return getPeriodLabel(period);
};

export default {
  PERIODS,
  getPeriodLabel,
  getPeriodTitle,
};
